export default __webpack_public_path__ + "static/media/ei-picture.df6d4a3d.svg";